module.exports = __webpack_public_path__ + "img/prize2.a2e08b8.png";